import { render } from "./AuthorizationBanner.vue?vue&type=template&id=20faa63e&scoped=true"
import script from "./AuthorizationBanner.vue?vue&type=script&lang=js"
export * from "./AuthorizationBanner.vue?vue&type=script&lang=js"

import "./AuthorizationBanner.vue?vue&type=style&index=0&id=20faa63e&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20faa63e"]])

export default __exports__